// extracted by mini-css-extract-plugin
module.exports = {"scheduleColumn":"DayField_scheduleColumn__20O1z","schedule":"DayField_schedule__3YgWn","scheduleBox":"DayField_scheduleBox__2Ieud","scheduleGroup":"DayField_scheduleGroup__KeFkI"};